/**
 * UHF (Universal Header Footer) configuration.
 */

/** UHF Shell Service base URL — direct access (UHF supports CORS) */
export const UHF_API_BASE = "https://uhf.microsoft.com";

/** UHF partner ID */
export const UHF_PARTNER_ID = "MSBZA";

/** UHF footer ID */
export const UHF_FOOTER_ID = "MSBZAFooterSimple";

/** Timeout in milliseconds for UHF API requests */
export const UHF_REQUEST_TIMEOUT = 5000;

/** sessionStorage key prefix for caching UHF responses */
export const UHF_CACHE_KEY_PREFIX = "uhf-footer-";

/**
 * Map app locale codes to UHF-compatible locale strings.
 * The app uses short codes (zh, en); UHF requires full locale (zh-cn, en-us).
 */
export const LOCALE_MAP: Record<string, string> = {
  zh: "zh-cn",
  en: "en-us",
};

/** Get UHF-compatible locale from app locale */
export function getUHFLocale (appLocale: string): string {
  return LOCALE_MAP[appLocale] || "en-us";
}

/** Get sessionStorage cache key for a given locale */
export function getCacheKey (locale: string): string {
  return `${UHF_CACHE_KEY_PREFIX}${locale}`;
}
